import type { ReactNode } from 'react';

import styles from './chip.module.scss';

export type ChipIntent =
  | 'neutral'
  | 'wip'
  | 'review'
  | 'approved'
  | 'attention'
  | 'published'
  // Device-status colorways from the FieldPro device listing (Figma 232:350661).
  | 'idle'
  | 'expired';

export type ChipProps = {
  /** Figma stage colorways (node 121:1927). */
  intent?: ChipIntent;
  /** Optional 10px trailing icon (Figma uses Phosphor Leaf). */
  icon?: ReactNode;
  className?: string;
  children: ReactNode;
};

export function Chip({ intent = 'neutral', icon, className, children }: ChipProps) {
  return (
    <span className={[styles.chip, styles[intent], className].filter(Boolean).join(' ')}>
      {children}
      {icon ? <span className={styles.icon}>{icon}</span> : null}
    </span>
  );
}

/** The six content-workflow stages from Figma node 121:1927. */
export const STAGE_CHIPS = {
  notStarted: { label: 'Not started', intent: 'neutral' },
  wip: { label: 'WIP', intent: 'wip' },
  review: { label: 'Review', intent: 'review' },
  approved: { label: 'Approved', intent: 'approved' },
  attention: { label: 'Attention', intent: 'attention' },
  published: { label: 'Published', intent: 'published' },
} as const satisfies Record<string, { label: string; intent: ChipIntent }>;
